import { inject } from 'inversify';

import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { IShopName } from '../interfaces';
import { ShopMapper } from '../mappers';

export type IGetShopByIdRepoResponse = IRepoResponse<200, IShopName> | IRepoResponse<400 | 500, string>;

export type IGetShopByIdRepo = IRepo<[number | string], IGetShopByIdRepoResponse>;

export const GetShopByIdRepoType = Symbol.for('GetPageShopByIdRepo');

@bind(GetShopByIdRepoType)
export class GetShopByIdRepo implements IGetShopByIdRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: number | string) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/shop_names/info', { shop_name_id: id }) });

      if (result.status === 200) {
        const data: IShopName = ShopMapper.toDomain(result.data.data);

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
